
export const userRoles = Object.freeze({
  ADMINISTRADOR_CONTRATO: 'Yclick! Administrador de Contrato',
  ADMINISTRADOR_GENERAL_CONTRATOS: 'Yclick! Administrador General de Contrato',
  INSPECTOR: 'Yclick! Inspector',
  REFERENTE_CONTROL_GESTION: 'Yclick! Referente Control de Gestion',
  CONTROL_ERRORES_SAP: 'Yclick! Control de errores SAP',
  PROVEEDOR_ADMINISTRADOR: 'Yclick! Proveedor Administrador',
  PROVEEDOR_NOTIFICADOR: 'Yclick! Proveedor Notificador',
  USUARIO_CONSULTAS: 'Yclick! Usuario Consulta',
  SOLICITANTE: 'Yclick! Solicitante',
  SUPERVISOR_NOTIFICADOR_YPF: 'Yclick! Supervisor Notificador YPF',
  APROBADOR: 'Yclick! Aprobador',
  REFERENTE_COMPRAS: 'Yclick! Referente Compras',
  RESPONSABLE_PEP_PROYECTO: 'Yclick! Responsable PEP Proyecto',
  GERENTE_COMPRA: 'Yclick! Gerente Compras',
  ADMINISTRADOR_USUARIO_EXTERNO: 'Yclick! AUE Administrador usuarios externos',
  ADMINISTRADOR_USUARIO_SEGURIDAD: 'Yclick! AUS Administrador usuarios seguridad',
  ADMINISTRADOR_USUARIO_PROPIEDADES: 'Yclick! AUP Administrador usuarios propiedades',
  AUDITOR_SEGURIDAD: 'Yclick! ADS Auditor de Seguridad',
  VISUALIZADOR_CONTRATOS: 'Yclick! Visualizador de contratos',
  LIBERADOR: 'Yclick! Liberador',
  CERTIFICADOR: 'Yclick! Certificador'
});
